export default {
  methods: {
    userCanEditByKostenstelle (data) {
      if (this.$store.getters['user/isAuthorized']) {
        let userKst = this.$store.getters['user/selectedOrga'].kostenstelle
        if (data.organisationseinheit != null && data.organisationseinheit.kostenstellenpfad != null) {
          let kostenstellen = data.organisationseinheit.kostenstellenpfad
          if (data.weitereOrganisationseinheiten != null) {
            kostenstellen += data.weitereOrganisationseinheiten.map(x => x.kostenstellenpfad).join(' ')
          }
          return kostenstellen.includes(userKst) || (this.$store.getters['user/roles'].ADMIN === true)
        } else {
          return this.$store.getters['user/roles'].ADMIN === true
        }
      } else {
        return false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/UserCanEditByKostenstelle.js